import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { UserRole } from '../../models';

export const roleGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for auth initialization to complete before checking authentication
  await authService.waitForInitialization();

  const requiredRoles = route.data['roles'] as UserRole[] | undefined;

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  await authService.ensureUserDataLoaded();
  if (!(await authService.enforceActiveAccountOrSignOut())) {
    return false;
  }

  if (authService.hasAnyRole(requiredRoles)) {
    return true;
  }

  // Redirect to appropriate dashboard based on user's actual role
  const currentRole = authService.userRole();
  if (currentRole) {
    router.navigate([authService.getRedirectUrlForRole(currentRole)]);
  } else {
    router.navigate(['/login']);
  }

  return false;
};

